import { render, staticRenderFns } from "./RevenueMap.vue?vue&type=template&id=580ece38&scoped=true"
import script from "./RevenueMap.vue?vue&type=script&lang=js"
export * from "./RevenueMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ece38",
  null
  
)

export default component.exports